import { Skeleton } from '@/components/ui/skeleton'

export function AppLoadingSkeleton() {
  return (
    <div className='bg-background min-h-svh'>
      <div className='mx-auto flex min-h-svh w-full'>
        <aside className='hidden w-72 border-r bg-muted/30 p-4 lg:block'>
          <div className='space-y-4'>
            <Skeleton className='h-8 w-44' />
            <Skeleton className='h-10 w-full' />
            <Skeleton className='h-10 w-full' />
            <Skeleton className='h-10 w-full' />
            <Skeleton className='h-10 w-full' />
          </div>
        </aside>
        <main className='flex-1 p-6'>
          <div className='mb-6 flex items-center justify-between gap-4'>
            <Skeleton className='h-9 w-72' />
            <Skeleton className='h-9 w-36' />
          </div>
          <div className='grid gap-4 md:grid-cols-2 xl:grid-cols-3'>
            <Skeleton className='h-36 w-full' />
            <Skeleton className='h-36 w-full' />
            <Skeleton className='h-36 w-full' />
          </div>
          <div className='mt-6 space-y-3'>
            <Skeleton className='h-12 w-full' />
            <Skeleton className='h-12 w-full' />
            <Skeleton className='h-12 w-full' />
            <Skeleton className='h-12 w-full' />
          </div>
        </main>
      </div>
    </div>
  )
}
